import { Component, OnInit } from "@angular/core";
import * as moment from "moment-timezone";
import { Observable } from "rxjs/Observable";
import { TAAConstants } from "../../../../../views/constants/taa-constants";
import { InternalTestService } from "../../services/internaltest.service";
import { RegexEnum } from "./../../../../../views/regex.enum";
import { TestAdministrationsService } from "./../../services/testadministrations.service";
@Component({
  templateUrl: "./testadministrations.component.html"
})
export class TestAdministrationsComponent implements OnInit {
  public testAdministrations: any = {};
  public testErr = "";
  public reqCutOfErr = "";
  public adminErr = "";
  public refAdminErr = "";
  public testDesErr = "";
  public statusErr = "";
  public shortErr = "";
  public regEndErr = "";
  public displayOrderErr = "";
  public statusCode: Array<any> = [];
  public dateType: Array<any> = [];
  public testName: any;
  public popUpType: string;
  public testAdmin: any = {};
  public display = "none";
  public msg: string = "";
  public regStartErr = "";
  public certiCutOfErr = "";
  public splStartErr = "";
  public splEndErr = "";
  public testDateTypeErr = "";
  public actAdminErr = "";
  public contractErr = "";
  public oldDisplayNumber: number;

  constructor(
    private testAdministrationsService: TestAdministrationsService,
    private internalTestService: InternalTestService,
    public taaConstants: TAAConstants
  ) {}

  ngOnInit() {
    this.testAdministrations = [];
    this.statusCode = [
      { id: "A", code: "Active" },
      { id: "I", code: "Inactive" },
      { id: "", code: "Please Select" }
    ];
    this.dateType = ["National", "Special", "State"];
    Observable.forkJoin(
      this.testAdministrationsService.getTestAdministrations(),
      this.internalTestService.getTest()
    ).subscribe(([resp, test]) => {
      this.testAdministrations = resp.body;
      this.testName = test;
    });
    this.resetForm();
  }

  openPopUp(item: any, type: string) {
    this.popUpType = type;
    this.oldDisplayNumber = item.DISPLAY_ORDER_NO;

    if (this.popUpType === "Edit") {
      this.testAdmin.TEST_ID = item.TEST_ID;
      this.testAdmin.TEST_DATE_ID = item.TEST_DATE_ID;
      this.testAdmin.TEST_DATE_TYPE = item.TEST_DATE_TYPE;
      this.testAdmin.DISPLAY_ORDER_NO = item.DISPLAY_ORDER_NO;
      this.testAdmin.STATUS_CD = item.STATUS_CD;
      this.testAdmin.TEST_DATE_NM = item.TEST_DATE_NM;
      this.testAdmin.ABBREV_SEASON_CD = item.ABBREV_SEASON_CD;
      this.testAdmin.REF_ADMIN_ID = item.REF_ADMIN_ID;
      this.testAdmin.ADMIN_ID = item.ADMIN_ID;
      this.testAdmin.ACT_ADMIN_ID = item.ACT_ADMIN_ID;
      this.testAdmin.CONTRACT_CD = item.CONTRACT_CD;
      this.testAdmin.REQUEST_CUT_OFF_DT = moment(item.REQUEST_CUT_OFF_DT)
        .utc()
        .format("MM/DD/YYYY");
      this.testAdmin.REVIEW_FROM_DT = moment(item.REVIEW_FROM_DT)
        .utc()
        .format("MM/DD/YYYY");
      this.testAdmin.REVIEW_TO_DT = moment(item.REVIEW_TO_DT)
        .utc()
        .format("MM/DD/YYYY");
      if (item.CERTIFY_CUT_OFF_DT) {
        this.testAdmin.CERTIFY_CUT_OFF_DT = moment(item.CERTIFY_CUT_OFF_DT)
          .utc()
          .format("MM/DD/YYYY");
      } else {
        this.testAdmin.CERTIFY_CUT_OFF_DT = null;
      }
      if (item.SPL_TEST_ADMIN_START_DT) {
        this.testAdmin.SPL_TEST_ADMIN_START_DT = moment(
          item.SPL_TEST_ADMIN_START_DT
        )
          .utc()
          .format("MM/DD/YYYY");
      } else {
        this.testAdmin.SPL_TEST_ADMIN_START_DT = null;
      }
      if (item.SPL_TEST_ADMIN_END_DT) {
        this.testAdmin.SPL_TEST_ADMIN_END_DT = moment(
          item.SPL_TEST_ADMIN_END_DT
        )
          .utc()
          .format("MM/DD/YYYY");
      } else {
        this.testAdmin.SPL_TEST_ADMIN_END_DT = null;
      }

      if (this.testAdmin.STATUS_CD === "Inactive") {
        this.testAdmin.STATUS_CD = "I";
      } else if (this.testAdmin.STATUS_CD === "Active") {
        this.testAdmin.STATUS_CD = "A";
      }
    } else {
      this.testAdmin.TEST_NM = "";
      this.testAdmin.TEST_ID = "";
      this.testAdmin.TEST_DATE_TYPE = "";
      this.testAdmin.DISPLAY_ORDER_NO = null;
      this.testAdmin.STATUS_CD = "";
      this.testAdmin.TEST_DATE_NM = "";
      this.testAdmin.ABBREV_SEASON_CD = null;
      this.testAdmin.REF_ADMIN_ID = null;
      this.testAdmin.ADMIN_ID = null;
      this.testAdmin.REQUEST_CUT_OFF_DT = "";
      this.testAdmin.REVIEW_FROM_DT = "";
      this.testAdmin.REVIEW_TO_DT = "";
      this.testAdmin.CERTIFY_CUT_OFF_DT = null;
      this.testAdmin.SPL_TEST_ADMIN_START_DT = null;
      this.testAdmin.SPL_TEST_ADMIN_END_DT = null;
      this.testAdmin.ACT_ADMIN_ID = null;
      this.testAdmin.CONTRACT_CD = null;
    }

    this.display = "block";
  }

  getTestAdminstration() {
    Observable.forkJoin(
      this.testAdministrationsService.getTestAdministrations()
    ).subscribe(([resp]) => {
      this.testAdministrations = resp.body;
      this.display = "none";
    });
  }

  closePopUpForm() {
    this.resetForm();
    this.display = "none";
  }
  validateForm(type) {
    const emptyOrOnlyWhiteSpace = new RegExp(RegexEnum.EMPTY_OR_WHITESPACE);
    if (type === "Add") {
      if (this.testAdmin.TEST_ID) {
        this.testName.forEach(element => {
          if (element.TEST_ID === this.testAdmin.TEST_ID) {
            this.testAdmin.TEST_NM = element.TEST_NM;
          }
        });
        this.testErr = "";
      } else {
        this.testErr = "Test is required";
      }

      if (emptyOrOnlyWhiteSpace.test(this.testAdmin.TEST_DATE_NM)) {
        const regex = new RegExp(RegexEnum.TEST_DATE_NAME_PATTERN);
        if (regex.test(this.testAdmin.TEST_DATE_NM)) {
          this.testDesErr = "";
        } else {
          this.testDesErr = "Test Administration Description is not valid";
        }
      } else {
        this.testDesErr = "Test Administration Description is required";
      }
    }

    if (!this.testAdmin.TEST_DATE_TYPE) {
      this.testDateTypeErr = "Test Date Type is required";
    } else {
      this.testDateTypeErr = "";
    }

    if (this.testAdmin.ABBREV_SEASON_CD) {
      if (emptyOrOnlyWhiteSpace.test(this.testAdmin.ABBREV_SEASON_CD)) {
        const regex = new RegExp(RegexEnum.ABBREV_SEASON_CD_PATTERN);
        if (regex.test(this.testAdmin.ABBREV_SEASON_CD)) {
          this.shortErr = "";
        } else {
          this.shortErr = "Short Season Code is not valid";
        }
      } else {
        this.shortErr = "Short Season Code is not valid";
      }
    } else {
      delete this.testAdmin.ABBREV_SEASON_CD;
    }

    if (this.testAdmin.ADMIN_ID) {
      const regex = new RegExp(RegexEnum.ONLY_NUMBER);
      if (regex.test(this.testAdmin.ADMIN_ID)) {
        this.adminErr = "";
      } else {
        this.adminErr = "Admin Id is not valid";
      }
    } else {
      this.testAdmin.ADMIN_ID = null;
      this.adminErr = "";
    }
    if (this.testAdmin.REF_ADMIN_ID) {
      const regex = new RegExp(RegexEnum.NUMBER_OR_COMMA);
      if (regex.test(this.testAdmin.REF_ADMIN_ID)) {
        this.refAdminErr = "";
      } else {
        this.refAdminErr = "Ref Admin ID is not valid";
      }
    } else {
      this.testAdmin.REF_ADMIN_ID = null;
      this.refAdminErr = "";
    }
    if (this.testAdmin.REQUEST_CUT_OFF_DT) {
      if (
        moment(this.testAdmin.REQUEST_CUT_OFF_DT, "MM/DD/YYYY", true).isValid()
      ) {
        this.reqCutOfErr = "";
      } else {
        this.reqCutOfErr = "Request Cut Off Date is not valid.";
      }
    } else {
      this.reqCutOfErr = "Request Cut Off Date is required";
    }
    if (this.testAdmin.REVIEW_FROM_DT) {
      if (moment(this.testAdmin.REVIEW_FROM_DT, "MM/DD/YYYY", true).isValid()) {
        this.regStartErr = "";
      } else {
        this.regStartErr = "Send to Registration Start Date is not valid";
      }
    } else {
      this.regStartErr = "Send to Registration Start Date is required";
    }

    if (this.testAdmin.REVIEW_TO_DT) {
      if (moment(this.testAdmin.REVIEW_TO_DT, "MM/DD/YYYY", true).isValid()) {
        this.regEndErr = "";
        if (this.regStartErr === "") {
          if (
            Date.parse(this.testAdmin.REVIEW_FROM_DT) >
            Date.parse(this.testAdmin.REVIEW_TO_DT)
          ) {
            this.regEndErr =
              "Send to Registration End Date must be later than or equal to Start date";
          }
        }
      } else {
        this.regEndErr = "Send to Registration End Date is not valid";
      }
    } else {
      this.regEndErr = "Send to Registration End Date is required";
    }

    if (this.testAdmin.CERTIFY_CUT_OFF_DT) {
      if (
        moment(this.testAdmin.CERTIFY_CUT_OFF_DT, "MM/DD/YYYY", true).isValid()
      ) {
        this.certiCutOfErr = "";
      } else {
        this.certiCutOfErr = "Certification Cut Off Date is not valid";
      }
    } else {
      this.testAdmin.CERTIFY_CUT_OFF_DT = null;
      this.certiCutOfErr = "";
    }
    if (this.testAdmin.SPL_TEST_ADMIN_START_DT) {
      if (
        moment(
          this.testAdmin.SPL_TEST_ADMIN_START_DT,
          "MM/DD/YYYY",
          true
        ).isValid()
      ) {
        this.splStartErr = "";
      } else {
        this.splStartErr = "Special Testing Admin Start Date is not valid";
      }
    } else {
      this.testAdmin.SPL_TEST_ADMIN_START_DT = null;
      this.splStartErr = "";
    }

    if (this.testAdmin.SPL_TEST_ADMIN_END_DT) {
      if (
        moment(
          this.testAdmin.SPL_TEST_ADMIN_END_DT,
          "MM/DD/YYYY",
          true
        ).isValid()
      ) {
        this.splEndErr = "";
        if (this.splStartErr === "") {
          if (
            Date.parse(this.testAdmin.SPL_TEST_ADMIN_START_DT) >
            Date.parse(this.testAdmin.SPL_TEST_ADMIN_END_DT)
          ) {
            this.splEndErr =
              "Special Testing Admin End Date must be later than or equal to Start date";
          }
        }
      } else {
        this.splEndErr = "Special Testing Admin End Date is not valid";
      }
    } else {
      this.testAdmin.SPL_TEST_ADMIN_END_DT = null;
      this.splEndErr = "";
    }

    if (!this.testAdmin.DISPLAY_ORDER_NO) {
      this.displayOrderErr = "Display Order No is required";
    } else {
      if (
        this.testAdmin.DISPLAY_ORDER_NO &&
        this.testAdministrations.length > 0
      ) {
        this.testAdmin.DISPLAY_ORDER_NO = Number(
          this.testAdmin.DISPLAY_ORDER_NO
        );
        if (this.oldDisplayNumber !== this.testAdmin.DISPLAY_ORDER_NO) {
          const duplicateNumber = this.testAdministrations.some(
            item => item.DISPLAY_ORDER_NO === this.testAdmin.DISPLAY_ORDER_NO
          );
          if (duplicateNumber) {
            this.displayOrderErr = "Display Order No must be unique";
          } else {
            this.displayOrderErr = "";
          }
        } else {
          this.displayOrderErr = "";
        }
      } else {
        this.displayOrderErr = "";
      }
    }

    if (this.testAdmin.CONTRACT_CD) {
      const regex = new RegExp(RegexEnum.ONLY_NUMBER);
      if (regex.test(this.testAdmin.CONTRACT_CD)) {
        this.contractErr = "";
      } else {
        this.contractErr = "Contract code is not valid";
      }
    } else {
      this.testAdmin.CONTRACT_CD = null;
      this.contractErr = "";
    }

    if (this.testAdmin.ACT_ADMIN_ID) {
      const regex = new RegExp(RegexEnum.ALPHANUM_SP_50_PATTERN);
      if (regex.test(this.testAdmin.ACT_ADMIN_ID)) {
        this.actAdminErr = "";
      } else {
        this.actAdminErr = "ACT Admin Id is not valid";
      }
    } else {
      this.testAdmin.ACT_ADMIN_ID = null;
      this.actAdminErr = "";
    }

    if (!this.testAdmin.STATUS_CD) {
      this.statusErr = "Status is Required";
    } else {
      this.statusErr = "";
    }
    if (
      this.shortErr ||
      this.splEndErr ||
      this.splStartErr ||
      this.statusErr ||
      this.testDateTypeErr ||
      this.adminErr ||
      this.regEndErr ||
      this.regStartErr ||
      this.reqCutOfErr ||
      this.displayOrderErr ||
      this.certiCutOfErr ||
      this.refAdminErr ||
      this.actAdminErr ||
      this.contractErr
    ) {
      return false;
    } else {
      if (type === "Add" && (this.testErr || this.testDesErr)) {
        return false;
      } else {
        return true;
      }
    }
  }

  save() {
    if (this.popUpType === "Add") {
      this.addRow();
    } else if (this.popUpType === "Edit") {
      this.editRow();
    }
  }

  addRow() {
    let addRow: boolean = false;
    addRow = this.validateForm("Add");
    if (addRow) {
      this.testAdministrationsService
        .addTestAdministration(this.testAdmin)
        .subscribe(
          response => {
            if (response) {
              this.msg = "Test Administration has been added successfully.";
              this.getTestAdminstration();
            }
          },
          err => {
            if (err.error.error.message.includes("TEST_DATE_NM")) {
              this.testDesErr = "Test Administration Description is not valid";
            } else if (err.error.error.message.includes("ABBREV_SEASON_CD")) {
              this.shortErr = "Short Season Code is not valid";
            } else if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
              this.displayOrderErr = "Display Order No is not Valid";
            }
          }
        );
    }
  }

  editRow() {
    let editRow: boolean = false;
    editRow = this.validateForm("Edit");
    if (editRow) {
      this.testAdministrationsService
        .editTestAdministration(this.testAdmin)
        .subscribe(
          response => {
            if (response) {
              this.msg = "All your changes have been saved.";
              this.getTestAdminstration();
            }
          },
          err => {
            if (err.error.error.message.includes("TEST_DATE_NM")) {
              this.testDesErr = "Test Administration Description is not valid";
            } else if (err.error.error.message.includes("ABBREV_SEASON_CD")) {
              this.shortErr = "Short Season Code is not valid";
            } else if (err.error.error.message.includes("DISPLAY_ORDER_NO")) {
              this.displayOrderErr = "Display Order No is not Valid";
            }
          }
        );
    }
  }

  resetForm() {
    this.msg = "";
    this.testErr = "";
    this.testDesErr = "";
    this.statusErr = "";
    this.displayOrderErr = "";
    this.shortErr = "";
    this.adminErr = "";
    this.refAdminErr = "";
    this.reqCutOfErr = "";
    this.regStartErr = "";
    this.regEndErr = "";
    this.certiCutOfErr = "";
    this.splStartErr = "";
    this.splEndErr = "";
    this.testDateTypeErr = "";
    this.actAdminErr = "";
    this.contractErr = "";
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/test-administrations/testadministrations.component.ts